import { type RTKQueryError } from './ReduxHelpers.types';

export const handleRTKQueryErrorLogging = (error: RTKQueryError) => {
    const status = error?.status;
    const eventPayload = {
        label: error.endpointPath,
        server_error: {
            path: error.endpointPath,
            status,
            message: error.data?.message,
        },
        fingerprint: error.endpointPath,
    };

    const ignorableErrors = [
        530, // cloudflare dns issue
    ];

    return {
        eventPayload,
        shouldNotify: !ignorableErrors.includes(status),
        errorForNotify: new Error(`Received status code ${status} in request to ${error.endpointPath}`),
    };
};
